/**
 * API 域名管理
 *
 * 根据环境返回对应的后端 API 域名
 * - 生产环境: 使用生产域名
 * - 其他环境 (测试/开发): 使用测试域名
 */

import { isProd } from '@/utils/env';

const DOMAIN = {
    TEST: 'https://magazine-api-sg.wanyol.com',
    PROD: 'https://magazine-api-gl.heytapmobile.com',
} as const;

export const getDomain = () => (isProd ? DOMAIN.PROD : DOMAIN.TEST);
